import API from './api';
import {
  api_url,
  api_v2_url,
  login_url,
  logout_url,
  change_password_url,
  reset_password_url,
} from './apiAuthUrls';
import {handle401, isSignInRequest} from "./interceptorsHandlers";

export const buildUrlFor = model => `${API.defaults.baseURL}${api_url}/${model}/`;

export const Urls = {
    ApiCustomer: API.defaults.baseURL + api_url + "/customers/",
    ApiDistribution: API.defaults.baseURL + api_url + "/distributions/",
    ApiProductOrder: API.defaults.baseURL + api_url + "/product_orders/",
    ApiProductBatch: API.defaults.baseURL + api_url + "/product_batches/",
    ApiProduction: API.defaults.baseURL + api_url + "/productions/",
    ApiProductionSummaryByProductExport: API.defaults.baseURL + api_url + "/productions/summary/",
    ApiOpenProduction: API.defaults.baseURL + api_url + "/productions_open_production/",
    ApiProductionsControlRecords: API.defaults.baseURL + api_url + "/productions_control_records/",
    ApiTicketExportProductions: API.defaults.baseURL + api_url + "/ticket_export_productions/",
    ApiTicketExportDistributions: API.defaults.baseURL + api_url + "/ticket_export_distributions/",
    ApiProductionConfiguration: API.defaults.baseURL + api_url + "/production_configurations/",
    ApiProductionConfigurationTypes: API.defaults.baseURL + api_url + "/production_types/",
    ApiProduct: API.defaults.baseURL + api_url + "/products/",
    ApiLocation: API.defaults.baseURL + api_url + "/locations/",
    ApiRawMaterial: API.defaults.baseURL + api_url + "/raw_materials/",
    ApiRawMaterialBatch: API.defaults.baseURL + api_url + "/raw_material_batches/",
    ApiSupply: API.defaults.baseURL + api_url + "/supplies/",
    ApiSupplyBatch: API.defaults.baseURL + api_url + "/supply_batches/",
    ApiReception: API.defaults.baseURL + api_url + "/receptions/",
    ApiProductReception: API.defaults.baseURL + api_url + "/product_receptions/",
    ApiSupplier: API.defaults.baseURL + api_url + "/suppliers/",
    ApiEmployee: API.defaults.baseURL + api_url + "/employees/",
    ApiNotification: API.defaults.baseURL + api_url + "/notifications/",
    ApiStockStat: API.defaults.baseURL + api_url + "/stock_stat/",
    ApiStockStatConfig: API.defaults.baseURL + api_url + "/stock_stat/products_config",
    ApiProductionStat: API.defaults.baseURL + api_url + "/production_stats/",
    ApiDashboardStats: API.defaults.baseURL + api_url + "/dashboard_stats/",
    ApiDashboardStatsCriticalStockItems: API.defaults.baseURL + api_url + "/dashboard_stats/critical_stock_items",
    ApiProductionDailyStat: API.defaults.baseURL + api_url + "/production_daily_stats/",
    ApiLogIn: API.defaults.baseURL + login_url,
    ApiLogOut: API.defaults.baseURL + logout_url,
    ApiUpdateFirstStepsFlags: API.defaults.baseURL + api_url + "/organizations/update_first_steps_flags",
    ApiChangePassword: API.defaults.baseURL + change_password_url,
    ApiResetPassword: API.defaults.baseURL + reset_password_url,
    ApiContactUs: API.defaults.baseURL + api_url + "/contact_us/send_message/",
    ApiSearch: API.defaults.baseURL + api_url + "/search",
    ApiReprocess: API.defaults.baseURL + api_url + "/reprocesses/",
    ApiFormConfiguration: API.defaults.baseURL + api_url + "/form_configurations/",
    ApiCustomFormConfiguration: API.defaults.baseURL + api_url + "/custom_form_configurations/",
    ApiControlRecordsFormConfiguration: API.defaults.baseURL + api_url + "/control_records_form_configurations/",
    ApiControlRecordsForm: API.defaults.baseURL + api_url + "/control_records_forms/",
    ApiCustomForm: API.defaults.baseURL + api_url + "/custom_forms/",
    ApiProductStockDecrease: API.defaults.baseURL + api_url + "/product_stock_decreases/",
    ApiReprocessStockDecrease: API.defaults.baseURL + api_url + "/reprocess_stock_decreases/",
    ApiRawMaterialStockDecrease: API.defaults.baseURL + api_url + "/raw_material_stock_decreases/",
    ApiSupplyStockDecrease: API.defaults.baseURL + api_url + "/supply_stock_decreases/",
    ApiNotificationMessage: API.defaults.baseURL + api_url + "/users/notification/",
    ApiTableColumnPreferences: API.defaults.baseURL + api_url + "/users/table_column_preferences",
    ApiNewsBanner: API.defaults.baseURL + api_url + "/news_banners",
    ApiAutoSignUp: API.defaults.baseURL + api_url + "/auto_sign_up/",
    ApiSubscribeUpgradePro: API.defaults.baseURL + api_url + "/subscriptions/upgrade_to_pro",
    ApiOrganization: API.defaults.baseURL + api_url + "/organizations/",
    ApiCodes: API.defaults.baseURL + api_url + "/codes/",
    ApiBarcodeConfigurations: API.defaults.baseURL + api_url + "/barcode_configurations/",
    ApiInventoryControlLookup: API.defaults.baseURL + api_url + "/inventory_control/lookup",
    ApiAdminOrganization: API.defaults.baseURL + api_url + "/admin/organizations/",
    ApiAdminCustomer: API.defaults.baseURL + api_url + "/admin/customers/",
    ApiAdminSupplier: API.defaults.baseURL + api_url + "/admin/suppliers/",
    ApiHealthCheck: API.defaults.baseURL + api_url + "/health_check",
    ApiImplementation: API.defaults.baseURL + api_url + "/implementation",
    ApiNonconformity: API.defaults.baseURL + api_url + "/nonconformities/",
    ApiNonconformityMesssage: API.defaults.baseURL + api_url + "/nonconformity_messages/",
    ApiNonconformityTag: API.defaults.baseURL + api_url + "/nonconformity_tags/",
    ApiAlert: API.defaults.baseURL + api_url + "/alerts/",
    ApiBatchRequest: API.defaults.baseURL + api_url + "/batch_requests/",
    v2: {
      ApiSearch: API.defaults.baseURL + api_v2_url + "/search",
      ApiRawMaterialBatch: API.defaults.baseURL + api_v2_url + "/search/raw_material_batches/",
      ApiSupplyBatch: API.defaults.baseURL + api_v2_url + "/search/supply_batches/",
      ApiReprocess: API.defaults.baseURL + api_v2_url + "/search/reprocesses/",
      ApiProductBatch: API.defaults.baseURL + api_v2_url + "/search/product_batches/",
      ApiDistribution: API.defaults.baseURL + api_v2_url + "/search/distributions/",
      ApiProduction: API.defaults.baseURL + api_v2_url + "/search/productions/",
    }
}

API.interceptors.response.use(
  function (response) {
    // Any 2xx status code
    return response;
  },
  function (error) {
    if (error?.response?.status === 401) {
      handle401(error);
      // Login failures must reject so AuthService.logIn can run catch → setAuthError.
      // Other 401s trigger a full-page redirect; a pending promise is fine there.
      if (isSignInRequest(error.config)) {
        return Promise.reject(error);
      }
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);
